export const ITEM_SHOP_LIST_REQUEST = 'ITEM_SHOP_LIST_REQUEST';

export const ITEM_SHOP_UPSERT_REQUEST = 'ITEM_SHOP_UPSERT_REQUEST';

export const ITEM_SHOP_INFO_REQUEST = 'ITEM_SHOP_INFO_REQUEST';

export const ITEM_SHOP_SORT_UPDATE_REQUEST = 'ITEM_SHOP_SORT_UPDATE_REQUEST';